export const DiscountQueryKeys = {
  all: ['package'] as const,
  lists: () => [...DiscountQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...DiscountQueryKeys.lists(), filters] as const,
  details: () => [...DiscountQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...DiscountQueryKeys.details(), id] as const,
};
